import React from 'react';
import { CreateUser } from '../..';

export const CreateENTAdmin = (props) => (
  <CreateUser title='Add New Admin' headText='Provide information for the new Admin' managedRole='Admin' {...props} />
);
